import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { DefaultButton } from 'shared/ui';
import styles from './cookie-banner.module.scss';

const COOKIE_CONSENT_KEY = 'bookup_cookie_consent';

export const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.banner__container}>
      <div className={styles.banner__content}>
        <p className={styles.banner__text}>
          Мы используем локальные хранилища (localStorage) для работы сервиса.
          Продолжая использование, вы соглашаетесь с{' '}
          <Link to={AppLinks.CookiePolicyLink} className={styles.banner__link}>
            Политикой cookie
          </Link>
          .
        </p>
        <DefaultButton
          buttonText="Принять"
          color="green"
          onClick={handleAccept}
        />
      </div>
    </div>
  );
};
